import React, { useState,  } from "react";
import Alert, { AlertProps } from "@mui/material/Alert";

export enum notificationType {
  Error = "error",
  Warning = "warning",
  Info = "info",
  Success = "success",
}

interface FdAlertProps extends AlertProps {
  props?: any;
  ref?: any;
  message?: string;
}

const FdAlert = ({ props, ref, message, ...rest }: FdAlertProps) => {
  const [type, ] = useState(notificationType.Info);


  return (
      <Alert
        severity={type}
        elevation={6}
        variant="filled"
        {...rest}
      >
        {message}
      </Alert>
  );
};

export default FdAlert;
